import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* createLookbook({ payload: { values, onSuccess, onError, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.lookbooks.create, data: values });

    onSuccess && onSuccess(data.result);
    yield put(actions.createLookbookDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.createLookbookFailed,
      onError: onError,
      handledErrors,
      endpoint: api.lookbooks.create.url
    });
  }
}

export const createLookbookSaga = takeEvery(types.CREATE_LOOKBOOK_REQUEST, createLookbook);